import { Bell } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";

import { useAskV2ReviewEmailNotificationCta } from "./useAskV2ReviewEmailNotificationCta";

import { ComposerActionBanner } from "../../components/ComposerActionBanner";

type AskV2ReviewEmailNotificationBannerProps = {
  chatId: string;
  reviewInProgress: boolean;
};

export function AskV2ReviewEmailNotificationBanner({
  chatId,
  reviewInProgress,
}: AskV2ReviewEmailNotificationBannerProps) {
  const { t } = useTranslation("ui");
  const { visible, enabling, enable, dismiss } =
    useAskV2ReviewEmailNotificationCta(chatId, reviewInProgress);

  if (!visible) return null;

  return (
    <ComposerActionBanner
      testId="ask-v2-review-email-notification-banner"
      primaryTestId="ask-v2-review-email-notification-banner-enable"
      ariaLabel={t("askV2.transport.reviewEmailNotificationBannerAriaLabel")}
      icon={
        <Bell
          size={16}
          weight="fill"
          className="mt-0.5 shrink-0 text-puntt-accent-11"
          aria-hidden="true"
        />
      }
      message={t("askV2.transport.reviewEmailNotificationBannerMessage")}
      primaryLabel={t("askV2.transport.reviewEmailNotificationBannerEnable")}
      onPrimary={() => {
        void enable();
      }}
      dismissLabel={t("askV2.transport.reviewEmailNotificationBannerDismiss")}
      onDismiss={dismiss}
      closeAriaLabel={t(
        "askV2.transport.reviewEmailNotificationBannerCloseAriaLabel",
      )}
      busy={enabling}
    />
  );
}
